import { render } from "./UpdateReleasePage.vue?vue&type=template&id=7a837508"
import script from "./UpdateReleasePage.vue?vue&type=script&lang=js"
export * from "./UpdateReleasePage.vue?vue&type=script&lang=js"

import "./UpdateReleasePage.vue?vue&type=style&index=0&id=7a837508&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__